<template>
  <div class="container">
    <div class="row">
      <div class="video-container feature-box col-md-12 text-center" :id="'feature-box-' + upcomingCeremony.id" v-if="upcomingCeremony.readyToStream">
        <iframe width="640" height="360" :src="upcomingCeremony.streamingVid" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
          Your browser cannot display iFrames. <a :href="upcomingCeremony.streamingVid">Click here to watch the livestream.</a>
        </iframe>
      </div>
      <div class="video-container ettiquite-box col-md-12" v-else>
        <iframe width="640" height="360" :src="ettiquiteVid" title="Commencement Etiquette" frameborder="0" allowfullscreen>
          Your browser cannot display iFrames. <a :href="ettiquiteVid">Click here to watch the commencement etiquette video.</a>.
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['ceremonies'],
  data () {
    return {
      ettiquiteVid: 'https://www.youtube.com/embed/E5Q5l8shhWA',
      upcomingCeremony: {} // To store the upcoming ceremony
    }
  },
  mounted () {
    // Get the latest ceremony data
    this.getUpcomingCeremony()
  },
  created () {
    let elem = document.createElement('script')
    elem.setAttribute('src', 'https://d36hc0p18k1aoc.cloudfront.net/pages/a5b5e5.js')
    document.head.appendChild(elem)
  },
  watch: {
    ceremonies: { // Track updates to ceremonies array from from parent component (allCeremonies.vue)
      handler (newArray, oldArray) {
        this.getUpcomingCeremony() // Get the completed ceremony data
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getUpcomingCeremony: function () { // Get the latest ceremony data
      // Store upcoming ceremony
      this.upcomingCeremony = this.ceremonies.find(el => el.nextUp)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .video-container {
    display: none;
    margin: 25px 0;
  }

  .video-container iframe {
    width: 100%;
    max-width: 640px;
    max-height: 360px;
    display: block;
    margin: auto;
  }

  @media (max-width: 400px) {
    .video-container iframe {
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/stream.vue